// 爆料网 · 话题与社区模拟数据
// 说明：仅供页面静态展示，讨论对象均以泛化称呼呈现，避免涉及真实个人。

export const siteProfile = {
  brand: "爆料网",
  slogan: "吃瓜群众已就位，热门话题第一现场",
  desc: "一个汇集明星八卦、娱乐影视、社会热议与科技热点讨论的在线社区，网友实时开麦，围观最新话题，参与真实讨论。",
  email: "hello@baoliaowang.cn",
};

export const hotTags = [
  "演唱会抢票",
  "新剧开播",
  "年度盛典",
  "选秀舞台",
  "美食探店",
  "数码新品",
  "体育大赛",
  "职场日常",
];

export const categories = [
  { id: "ent", name: "娱乐瓜田", desc: "明星八卦 · 演唱会 · 综艺趣事", icon: "ri-vip-crown-2-line", tone: "primary" },
  { id: "film", name: "影视综艺", desc: "热剧讨论 · 电影口碑 · 真人秀", icon: "ri-movie-2-line", tone: "secondary" },
  { id: "life", name: "生活方式", desc: "美食探店 · 旅行分享 · 情感树洞", icon: "ri-cup-line", tone: "accent" },
  { id: "tech", name: "科技数码", desc: "新品发布 · 配置实测 · 价格讨论", icon: "ri-smartphone-line", tone: "primary" },
  { id: "society", name: "社会话题", desc: "时事热点 · 民生关切 · 冷门科普", icon: "ri-community-line", tone: "secondary" },
  { id: "sport", name: "体育电竞", desc: "赛事复盘 · 选手热议 · 电竞资讯", icon: "ri-trophy-line", tone: "accent" },
];

export const discussions = [
  {
    id: "t01",
    category: "ent",
    categoryName: "娱乐瓜田",
    tag: "爆",
    tagTone: "primary",
    title: "某顶流官宣新巡演，首站门票秒空后黄牛加价引网友怒议",
    summary:
      "时隔三年再度开启全国巡演，官宣当晚售票平台直接崩了。一边是粉丝哭喊抢不到票，一边是黄牛群里疯狂加价，讨论区吵翻了：到底该不该整治抢票乱象？",
    author: { name: "前排吃瓜", tone: "primary", initial: "前" },
    time: "18 分钟前",
    likes: 12840,
    comments: 3289,
    views: "421w",
    heat: 99,
    rank: 1,
  },
  {
    id: "t02",
    category: "society",
    categoryName: "社会话题",
    tag: "热",
    tagTone: "secondary",
    title: "高温天气外卖骑手仍被要求限时送达，网友为劳动者支招",
    summary:
      "多地连日高温，外卖小哥顶着烈日送单的新闻刷屏。有人说平台该调整考核，也有人分享如何正确点单减少骑手压力。评论区从体谅吵到了制度，讨论非常热烈。",
    author: { name: "热心市民", tone: "secondary", initial: "热" },
    time: "42 分钟前",
    likes: 9210,
    comments: 2140,
    views: "280w",
    heat: 93,
    rank: 2,
  },
  {
    id: "t03",
    category: "tech",
    categoryName: "科技数码",
    tag: "新",
    tagTone: "accent",
    title: "旗舰新机发布：影像再升级，价格却悄悄上调，值不值得冲？",
    summary:
      "今年旗舰的影像配置确实拉满，一英寸大底、全新算法全安排上了。可起售价也水涨船高，不少老用户直呼背刺。旧机还能再战一年吗？真实体验党已下场开麦。",
    author: { name: "数码老白", tone: "accent", initial: "数" },
    time: "1 小时前",
    likes: 7630,
    comments: 1882,
    views: "198w",
    heat: 87,
    rank: 3,
  },
  {
    id: "t04",
    category: "life",
    categoryName: "生活方式",
    tag: "热",
    tagTone: "primary",
    title: "深夜社恐点奶茶的尴尬瞬间，评论区成了大型共情现场",
    summary:
      "一位网友发帖吐槽自己深夜鼓起勇气进奶茶店，结果因为叫错口音社死当场。没想到评论区瞬间涌入上千条「同款社死」经历，温馨又好笑，治愈了很多人。",
    author: { name: "社恐本恐", tone: "primary", initial: "社" },
    time: "2 小时前",
    likes: 6540,
    comments: 1721,
    views: "156w",
    heat: 82,
    rank: 4,
  },
  {
    id: "t05",
    category: "film",
    categoryName: "影视综艺",
    tag: "新",
    tagTone: "secondary",
    title: "口碑黑马悬疑剧大结局引全网分析，编剧埋的伏笔你发现了吗",
    summary:
      "前六集口碑平平，结果结局封神，直接把热搜顶上去。网友连夜二刷逐帧找伏笔，讨论区已经出了几十版剧情解析，编剧本人也悄悄空降回应，热闹极了。",
    author: { name: "追剧狂魔", tone: "secondary", initial: "剧" },
    time: "3 小时前",
    likes: 5220,
    comments: 1436,
    views: "132w",
    heat: 78,
    rank: 5,
  },
  {
    id: "t06",
    category: "sport",
    categoryName: "体育电竞",
    tag: "热",
    tagTone: "accent",
    title: "季后赛焦点战再现绝杀时刻，主场球迷沸腾整个球馆",
    summary:
      "最后 3 秒落后 2 分，谁也没想到一记超远三分直接绝杀，把悬念留到了最后一刻。赛后更衣室画面曝光，教练红了眼眶，网友：这就是竞技体育的魅力。",
    author: { name: "篮下解说员", tone: "accent", initial: "篮" },
    time: "5 小时前",
    likes: 4980,
    comments: 1102,
    views: "118w",
    heat: 75,
    rank: 6,
  },
  {
    id: "t07",
    category: "ent",
    categoryName: "娱乐瓜田",
    tag: "新",
    tagTone: "secondary",
    title: "年度盛典红毯造型盘点：谁封神谁翻车？网友直呼审美回归",
    summary:
      "昨晚的年度盛典红毯刷屏一整天，几套高定造型被反复转发。有人在评论区逐套打分，也有人考古出多年前的经典红毯造型对比，审美讨论热度居高不下。",
    author: { name: "红毯观察员", tone: "secondary", initial: "毯" },
    time: "6 小时前",
    likes: 4103,
    comments: 986,
    views: "96w",
    heat: 71,
    rank: 7,
  },
  {
    id: "t08",
    category: "tech",
    categoryName: "科技数码",
    tag: "议",
    tagTone: "primary",
    title: "AI 一键生成视频再升级，创作者担心饭碗不保吵翻天",
    summary:
      "全新的 AI 视频工具能根据一句话生成完整短片，效率惊人。一边是内容创作者担心被替代，一边是技术党认为这是生产力解放。评论区双方各执一词，火药味十足。",
    author: { name: "科技观察家", tone: "primary", initial: "观" },
    time: "8 小时前",
    likes: 3876,
    comments: 903,
    views: "84w",
    heat: 68,
    rank: 8,
  },
  {
    id: "t09",
    category: "life",
    categoryName: "生活方式",
    tag: "议",
    tagTone: "accent",
    title: "共享厨房创业半年复盘，店主晒真实账本引发共鸣",
    summary:
      "一位小店老板分享自己开共享厨房的半年经历，从选址踩坑到营收爬坡全都公开。评论区既有创业者支招，也有过来人提醒风险，干货与故事并存，很值得一看。",
    author: { name: "开店日记", tone: "accent", initial: "店" },
    time: "10 小时前",
    likes: 3420,
    comments: 766,
    views: "72w",
    heat: 64,
    rank: 9,
  },
];

export const chatter = [
  { name: "熬夜冲浪选手", text: "这个瓜保熟吗？蹲一个后续，前排拿好小板凳。", time: "2 分钟前", tone: "accent", initial: "浪" },
  { name: "理性吃瓜人", text: "先别急着下结论，等当事人回应了再讨论也不迟。", time: "12 分钟前", tone: "primary", initial: "理" },
  { name: "站队墙头草", text: "两边说法都看了，信息量太大，今晚失眠预定。", time: "25 分钟前", tone: "secondary", initial: "墙" },
  { name: "评论区一姐", text: "我就知道这事会上热榜，评论区果然没让我失望。", time: "38 分钟前", tone: "primary", initial: "评" },
];

export const faqs = [
  {
    q: "如何参与到网站的热议讨论中？",
    a: "你无需注册即可在大部分热门话题下方查看网友评论并实时表态。想发言时，点击感兴趣的话题卡片进入详情，即可看到评论区并发表你的看法，点赞或回复其他网友的观点。",
  },
  {
    q: "发现内容不实或引战评论该怎么办？",
    a: "每条话题与评论下方都设有「举报」入口。若你认为某条爆料缺乏依据、或存在辱骂引战内容，可一键提交举报，我们的社区巡查团队会尽快核实并处理。",
  },
  {
    q: "为什么我的评论需要审核？",
    a: "为营造理性友好的围观氛围，涉及极端引战、人身攻击或可能侵犯他人隐私的评论会进入人工审核。正常表达观点的评论通常会被即时放行。",
  },
  {
    q: "网站上的「热榜」排名是怎么产生的？",
    a: "热榜综合了话题的实时评论增长量、点赞数与围观人次，动态更新。讨论越激烈、参与人数越多的话题，排名上升越快，因此热榜能反映当下网友最关心的事。",
  },
  {
    q: "如何向我喜欢的话题投稿爆料？",
    a: "点击页面底部的「我要爆料」，填写话题所属分类、标题、事件描述与联系方式后提交即可。审核通过后，你的投稿会以匿名或署名形式展示给全网网友围观讨论。",
  },
];

export const statsBand = [
  { value: "1260w", label: "累计围观人次" },
  { value: "38w", label: "在线吃瓜群众" },
  { value: "92%", label: "话题 24h 内上榜" },
  { value: "48", label: "热门讨论专区" },
];